import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { getFieldSets } from '../services/run-detail.service';

/** The run's requested / delivered / enriched fields — shared by Overview and Approval; `enabled`
 *  lets the stage pane read it only while the Approval pane is open. */
export function useRunFieldSets(runRef: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.catalogService.runFieldSets(runRef),
    queryFn: () => getFieldSets(runRef),
    enabled: enabled && !!runRef,
  });
}
